import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "error", "loading"];
import { useMemo } from 'react';
import { useQuery, useDataFetchingClient } from 'data-fetching-client';
import { useDispatch, useSelector } from 'react-redux';
import Log from 'forms-utils-lib/logger/Logger';
// @ts-expect-error untyped dependency
import { getFormGuid } from 'FormsUI/selectors/FormDefinition';
import { GET_FORM_ROUTING, GET_FORM_ROUTING_FIELD_NAME } from '../queries/getFormRouting';
import { SINGLE_REDIRECT, ROUTE_STATE, FETCH_ROUTING_ERROR } from 'FormsUI/constants/Routing';
import { hasRoutingAccess as hasRoutingAccessFromSelector } from 'FormsUI/selectors/Scope';
// @ts-expect-error untyped dependency
import { publishFormError } from 'FormsUI/actions/FormSaving';
const useFetchFormRouting = () => {
  const formGuid = useSelector(getFormGuid);
  const hasRoutingAccess = useSelector(hasRoutingAccessFromSelector);
  const dispatch = useDispatch();
  const hasAccessToRouting = hasRoutingAccess;
  const client = useDataFetchingClient();
  const showFetchRoutingError = () => {
    dispatch(publishFormError(FETCH_ROUTING_ERROR));
  };
  const _useQuery = useQuery(GET_FORM_ROUTING, {
      variables: {
        formGuid
      },
      skip: !formGuid || !hasAccessToRouting,
      onError({
        networkError
      }) {
        const {
          status: statusCode
        } = networkError;
        switch (statusCode) {
          // if form routing does not exist create a soft copy in the cache for the initial state
          case 404:
            if (formGuid) client.cache.writeQuery({
              query: GET_FORM_ROUTING,
              variables: {
                formGuid
              },
              data: {
                [GET_FORM_ROUTING_FIELD_NAME]: Object.assign({}, SINGLE_REDIRECT, {
                  routeState: ROUTE_STATE.DISABLED,
                  formId: formGuid
                })
              }
            });
            break;
          case 0:
            return;
          default:
            Log.error('failed to fetch forms routing', {
              statusCode
            });
            showFetchRoutingError();
        }
      }
    }),
    {
      data,
      error,
      loading: formRoutingLoading
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const formRouting = data && data[GET_FORM_ROUTING_FIELD_NAME];
  const isErrored = useMemo(() => {
    if (!error) return false;
    const statusCode = error.networkError.status;
    return statusCode !== 404;
  }, [error]);
  return Object.assign({
    formRouting,
    formRoutingLoading,
    isErrored,
    hasAccessToRouting,
    showFetchRoutingError
  }, rest);
};
export default useFetchFormRouting;